import React from 'react';
import { Table } from 'reactstrap';

const TableSubscription = (props) => {
  return (
    <Table style={{ maxWidth: 600, alignSelf: 'center' }} className="tbl-price" bordered>
      <thead>
        <tr>
          <th>Type</th>
          <th>Limited Professional</th>
          <th>Professional Developer</th>
          <th>Teams and Corporate</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Android, iOS, or Web</td>
          <td>100 USD/ month per app</td>
          <td>​</td>
          <td>​</td>
        </tr>
        <tr>
          <td>Android and iOS</td>
          <td>​167 USD/ month</td>
          <td>​</td>
          <td>​</td>
        </tr>
        <tr>
          <td>
          Android, iOS, and Web (combined)
          </td>
          <td>​259 USD/ month</td>
          <td>​</td>
          <td>​</td>
        </tr>
        <tr>
          <td>Hosting</td>
          <td>​based on consumption</td>
          <td>​optional</td>
          <td>​optional</td>
        </tr>

        <tr>
          <td>Source code push to Git</td>
          <td>No</td>
          <td>​yes</td>
          <td>​yes</td>
        </tr>
       
      </tbody>
    </Table>
  );
}

export default TableSubscription;